import React from 'react'
import { saveAs } from 'file-saver'
import * as S from './styles'
import downloadIcon from '../../assets/icons/download-icon.svg'

const DownloadCards = ({ files = [] }) => {
  const downloadHandler = (url, name) => () => {
    if (!url) { return false }
    try {
      saveAs(url, name)
      return true
    } catch (error) {
      console.error('Erro durante a request para download do arquivo:', error)
    }
  }

  return (
    <S.DownloadCards>
      {files.map(({ url, _id, name, size, type }) => (
        <S.DownloadCard key={_id} onClick={downloadHandler(url, name)} download>
          <S.DownloadCardInfo>
            <S.DownloadCardInfoContainer>
              <S.FileName>{name}</S.FileName>
              <S.FileInfo>{size}, {type.toUpperCase()}</S.FileInfo>
            </S.DownloadCardInfoContainer>
          </S.DownloadCardInfo>
          <img src={downloadIcon} alt='download'/>
        </S.DownloadCard>
      ))}
    </S.DownloadCards>
  )
}

export default DownloadCards
